import type { Academy } from '@/dto/Academy'

import { convertAcademyToUserProperties, type UserPropertiesSchema } from './userProperties.schema'

// Academy 속성에 academy_ 접두사를 붙인 타입
type PrefixedAcademyProperties = {
  [K in keyof UserPropertiesSchema as `academy_${K}`]: UserPropertiesSchema[K]
}

// Teacher 속성에 teacher_ 접두사를 붙인 타입
type PrefixedTeacherProperties = {
  teacher_D코드: res.Teacher['academyId']
  teacher_T코드: res.Teacher['teacherId']
  teacher_로그인ID: res.Teacher['loginId']
  teacher_이름: res.Teacher['name']
  teacher_전화번호: res.Teacher['phoneNumber']
  teacher_권한타입: res.Teacher['type'] // type 대신 isRootManager 사용
}

export type GlobalEventPropertiesSchema = PrefixedAcademyProperties &
  PrefixedTeacherProperties & {
    globalPropertiesVersion: 'v1.0' // data tracking2 출범하면서 v1.0 버전 사용
    globalPropertiesUpdateDate: '2025-07-30'
  }

export const convertAcademyAndTeacherToGlobalEventProperty = ({
  academy,
  teacher,
}: {
  academy: Academy
  teacher: res.Teacher
}): Partial<GlobalEventPropertiesSchema> => {
  const academyProperties = convertAcademyToUserProperties({ academy })
  const prefixedAcademyProperties = Object.entries(academyProperties).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [`academy_${key}`]: value,
    }),
    {} as PrefixedAcademyProperties,
  )

  return {
    ...prefixedAcademyProperties,
    teacher_D코드: teacher.academyId,
    teacher_T코드: teacher.teacherId,
    teacher_로그인ID: teacher.loginId,
    teacher_이름: teacher.name,
    teacher_전화번호: teacher.phoneNumber,
    teacher_권한타입: teacher.type,
  }
}
